import { utilities } from '@cornerstonejs/metadata';
const { addDicomPart10Instance } = utilities;
export function prefetchPart10Instance(baseImageId, part10) {
    return addDicomPart10Instance(baseImageId, part10);
}
export default prefetchPart10Instance;
